import React, { Component } from "react";
import { Dimmer, Loader, Message } from "semantic-ui-react";
import PreDailyHeader from "./headers/predailyheader";
import PreDailyStatement from "./statements/predaily";
import PreDailyStatementCanada from "./statements/preDailyCanada";
import accountAPI from "../../../../../apiCalls/accountAPI";
import MonthlyStatement from "./statements/monthly";
import { get, isEqual, debounce, isEmpty, cloneDeep, isUndefined } from "lodash";
import { Button, Checkbox, Icon, Dropdown } from "semantic-ui-react";
import DateInputField from "../../../../../commonComponents/SematicDateField";
import { convertEpochToDateAdvanced, convertNumberStringToDate } from '../../../../../util/constants';
import moment from 'moment';
import MonthlyModal from "./statements/monthlyModal";
import { getCookie } from "../../../../../util/index";
import "../../../../../styleSheets/sass/components/engineStatement.scss";
import { getQueryVariable } from "../../../../../apiCalls/jobInfo";

let pageSize = 10;
const monthlypageSize = 10;
let lastDate = "";
let lastFilerCode = "";
let lastCustomer = "";
let isBroker = true;

let date = new Date();
date.setHours(0, 0, 0, 0);
date.setDate(date.getDate());
const defaultStartDate = date;
const defaultEndDate = date;
let heading = "Pending Authorization", lastHeading = "";
let lastApiCount = -1;
let lastPoFilter = -1;
let lastPortFilter = -1;
let lastTransactionNoFilter = -1;
let lastGroupBy = -1;
let lastFromDateFilter = -1;
let lastToDateFilter = -1;
let isEngine = getQueryVariable('onlyOneShipment');
let enginePaymentCountry = getQueryVariable('paymentCountry');

class PreDailyPage extends Component {
  constructor(props) {
    super(props);

    pageSize = (this.whichCountry() === "canada") ? 9999 : 10; //to remove pagination

    this.state = {
      open: false,
      values: [],
      detailPage: false,
      prelimStatements: [],
      isLoading: true,
      typeSelected: "DAILY",
      dailyStatements: this.whichCountry() === "US" ? {
        authPending: [],
        authTransmitted: [],
      } : [],
      monthlyStatements: [],
      counter: pageSize,
      loadingState: false,
      loadingDone: false,
      apiCount: 1,
      appliedFromDate: null,
      appliedToDate: null,
      isApiCallDone: true,
      totalDailyStatement: 0,
      totalMonthlyStatement: 0,
      monthlyCounter: monthlypageSize,
      monthlyLoadingState: false,
      monthlyLoadingDone: false,
      apiError: false,
      errorApiCount: 0,

      searchValue: "",
      searchError: false,
      searchLoading: false,
      archived: false,
      auth: false,
      unauth: true,
      showDropDown: false,
      groupBy: this.whichCountry() === "US" ? "fileCode" : "NONE",
      brokerFilerFilter: "",
      transactionNoFilter: "",
      poFilter: "",
      portFilter: "",
      fromDateFilter: this.whichCountry() === "US" ? undefined : defaultStartDate,
      toDateFilter: this.whichCountry() === "US" ? undefined : defaultStartDate,
      toDateMsg: "",
      fromDateMsg: "",
      showingAdvancedSearch: false,
      searchApplied: false,
      dailyPageCount: 1,
      monthlyPageCount: 1,
      nav: "next",
      country: this.whichCountry(),
      totalSima: 0,
      totalExcise: 0,
      totalDuties: 0,
      totalGST: 0,
      totalPenalty: 0,
      totalInterest: 0,
      grandTotal: 0,
      lastPageReached: false,
      usersCountry: "",
      kxUser: this.props.kxUser
      // alerttype: null,
      // alertMsg: null
    };
    this.setStatementType = this.setStatementType.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.lastTabClicked = "DAILY";
    this.scrollHandler = this.scrollHandler.bind(this);
    this.getStatementData = this.getStatementData.bind(this);
    this.whichCountry = this.whichCountry.bind(this);
  }

  convertToISO(str) {
    return moment(str).toISOString();
  }

  whichCountry = () => {
    let countryCode = get(this.state, "kxUser.userInfo.brokerAdditionalInfo.countryOfBusiness", "");
    if (countryCode === "CANADA" || (isEngine && enginePaymentCountry==='ca'))
      return "canada";
    else if (countryCode === "UNITED_STATES")
      return "US";
    else if (countryCode === "UNITED_KINGDOM")
      return "UK";
  }

  isEmpty = (obj) => {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  };


  changeIsoToKnFormat = (isoDate) => {

    if (!isoDate) return "";
    let [year, month, day] = isoDate.split('-');



    let monthMapping = {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sep',
      '10': 'Oct',
      '11': 'Nov',
      '12': 'Dec',
    }
    return `${monthMapping[month]} ${day}, ${year}`;
  }

  sortData = (array) => {
    array.sort((a, b) => {
      a = new Date(a.value.statementPrintDate);
      b = new Date(b.value.statementPrintDate);
      return b - a;
    });
    return array;
  };

  setStatementType = (type) => {

    let stateChanges = {};
    if (this.whichCountry() === "US") {
      stateChanges = {
        typeSelected: type,
        unauth: true,
        auth: false,
        fromDateFilter: undefined,
        toDateFilter: undefined,
        appliedFromDate: null,
        appliedToDate: null,
        showingAdvancedSearch: false,
        searchApplied: false
      }
    } else {
      stateChanges = {
        typeSelected: type
      }
    }

    this.setState(stateChanges, () => {
      this.searchInvoice(1, type, this.lastTabClicked);
      this.lastTabClicked = type;
    });


  };

  setCountry = (country) => {
    this.setState({
      country: country,
    }, () => this.getStatementData());
  };

  componentWillMount = async () => {
    accountAPI.getUserInfo(getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN))
      .then((responses) => {
        return Promise.all(responses.map(function (res) {
          return res.json();
        }));
      })
      .then((responseData) => {
        if (responseData[0].msg == "Failed") {
          console.error("Some thing went wrong!!")
        }
        let kxUserData = responseData[0].eventMessage;
        this.setState({ "kxUser": kxUserData }, () => {
          //console.log("In callback", this.state.kxUser);
          this.setState({
            "country": this.whichCountry(),
            dailyStatements: this.whichCountry() === "US" ? {
              authPending: [],
              authTransmitted: [],
            } : []
          }, ()=>{
            this.getStatementData()
          })
         
        })
      })

  };

  componentDidUpdate(prevProps, prevState) {
    let { typeSelected } = this.state;
    if (!isEqual(prevState.typeSelected, typeSelected)) {
      this.setState({ apiError: false, isApiCallDone: true, counter: pageSize, apiCount: 1, loadingState: false, loadingDone: false, searchLoading: false });
    }
    if (!isEqual(prevProps.statmentSelctedFromKlearView, this.props.statmentSelctedFromKlearView)) {
      this.props.statmentSelctedFromKlearView !== "" && this.setState({ searchValue: this.props.statmentSelctedFromKlearView });

    }
    // if(this.whichCountry() === "canada") {
    //   this.scrollHandler();
    //   this.setState({"alreadyLoadedAfterUpdate": true})
    // }
  }

  openDetail = () => {
    this.setState({ detailPage: true });
  };

  closeDetail = () => {
    this.setState({ detailPage: false });
  };

  componentDidMount() {
    this.setState({ appliedFromDate: this.state.fromDateFilter });
    this.setState({ appliedToDate: this.state.toDateFilter });
    let currentUrl = window.location.href;
    if (currentUrl.includes('custom-statement')) {
      this.setState({ "statementClass": "custom-statement" })
    }
    lastApiCount = -1;
    lastPoFilter = -1;
    lastPortFilter = -1;
    lastTransactionNoFilter = -1;
    lastGroupBy = -1;
    lastFromDateFilter = -1;
    lastToDateFilter = -1;

    if (this.whichCountry() === "canada") {
      this.refs.iScroll.addEventListener("scroll", this.scrollHandler);
    }
  }


  componentWillUnmount() {
    if (this.whichCountry() === "canada") {
      this.refs.iScroll.removeEventListener("scroll", this.scrollHandler);
    }
    this.props.updateStatementSelcetedFromKlearView("")
  }

  formatAmount = (num) => { //add leading zeroes
    num = String(num)
    var value = Number(num);
    var res = num.split(".");
    if (res.length == 1 || res[1].length < 3) {
      value = value.toFixed(2);
    }
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');  //add commas

  }

  scrollHandler = debounce(() => {
    let { typeSelected } = this.state;
    if (document.querySelector(".stmt_pixel") && document.querySelector(".stmt_pixel").getBoundingClientRect().bottom < window.innerHeight) {
      if (typeSelected === "DAILY") {
        this.loadMoreItemsCanada();
      }
      // if (typeSelected === "MONTHLY") {
      //   this.loadMoreItems();
      // }
    }
  }, 500);

  getStatementData = async (retainPageNumber = false) => {

    const {
      dailyStatements: { authPending, authTransmitted },
      monthlyStatements: newMonthlyStatements,
      apiCount,
      errorApiCount,
      country,
      poFilter,
      portFilter,
      transactionNoFilter,
      groupBy,
      fromDateFilter,
      toDateFilter
    } = this.state;

    try {
      if (this.whichCountry() === "canada" && lastApiCount === apiCount && lastPoFilter === poFilter && lastPortFilter === portFilter && lastTransactionNoFilter === transactionNoFilter && lastGroupBy === groupBy && lastFromDateFilter === fromDateFilter && lastToDateFilter === toDateFilter) { //if last call is being made again
        return;
      }

      if (this.state.country === "canada" && !retainPageNumber)
        this.setState({ 'dailyPageCount': 1 });

      if (apiCount === 1)
        this.setState({ loadingState: true, isApiCallDone: false, isLoading: true });
      else
        this.setState({ loadingState: true, isApiCallDone: false });

      let eventId = await get(this.state, "kxUser.userBasicInfo.userGuid", "");
      
      let filerCode = await get(this.state, "kxUser.userInfo.brokerAdditionalInfo.filerCode") || get(this.state, "kxUser.userInfo.brokerAdditionalInfo.accountSecurityNumber", "");

      lastApiCount = apiCount;
      lastPoFilter = poFilter;
      lastPortFilter = portFilter;
      lastTransactionNoFilter = transactionNoFilter;
      lastGroupBy = groupBy;
      lastFromDateFilter = fromDateFilter;
      lastToDateFilter = toDateFilter;
      let response = await accountAPI.getDailyPreAuth(filerCode, apiCount, this.state.searchValue, this.state, undefined, eventId, isEngine);

      this.setState({
        totalSima: get(response, 'data.eventMessage.totalSima', 0),
        totalExcise: get(response, 'data.eventMessage.totalExcise', 0),
        totalDuties: get(response, 'data.eventMessage.totalDuties', 0),
        totalGST: get(response, 'data.eventMessage.totalGST', 0),
        totalPenalty: get(response, 'data.eventMessage.totalPenalty', 0),
        totalInterest: get(response, 'data.eventMessage.totalInterest', 0),
        grandTotal: get(response, 'data.eventMessage.GrandTotal', 0),
        usersCountry: get(response, 'data.eventMessage.country', ''),
      });
      if (this.whichCountry() !== "canada" && (Object.keys(response.data.eventMessage).length === 0 ||
        (!response.data.eventMessage.totalStatements &&
          !response.data.eventMessage.dailyStatementDetails.length &&
          !response.data.eventMessage.totalMonthlyStatement))) {
        if (this.state.typeSelected === "DAILY") {
          response.data.eventMessage = {
            dailyStatementDetails: [],
            monthlyStatementDetails: [],
            totalStatements: this.state.monthlyStatements.length,
            totalDailyStatement: this.whichCountry() === "US" ? this.state.dailyStatements.authTransmitted.length + this.state.dailyStatements.authPending.length : 0,
            totalMonthlyStatement: this.state.monthlyStatements.length
          };

        } else {
          response.data.eventMessage = {
            dailyStatementDetails: [{
              authTransmitted: [],
              authPending: []
            }],
            monthlyStatementDetails: [],
            totalStatements: this.state.dailyStatements.authTransmitted.length + this.state.dailyStatements.authPending.length,
            totalDailyStatement: this.state.dailyStatements.authTransmitted.length + this.state.dailyStatements.authPending.length,
            totalMonthlyStatement: this.state.monthlyStatements.length
          };

        }
      }

      let dStatements, mStatements;
      
      if (response.data.eventMessage.statements) {
        dStatements = [];
        mStatements = [];
        for (let i = 0; i < response.data.eventMessage.statements.length; i++) {
          dStatements.push(response.data.eventMessage.statements[i].value.dailyStatementDetails);
          mStatements.push(response.data.eventMessage.statements[i].value.monthlyStatementDetails);
        }
        dStatements = dStatements.flat();
        mStatements = mStatements.flat();

      } else {
        dStatements = get(response, "data.eventMessage.dailyStatementDetails", []);
        mStatements = get(response, "data.eventMessage.monthlyStatementDetails", []);
      }

      if (dStatements || mStatements) {
        let dailyStatements = dStatements ? dStatements : [];
        let monthlyStatements = mStatements ? mStatements : [];
        let totalDailyStatement = get(response, "data.eventMessage.totalDailyStatement", 0);
        let totalMonthlyStatement = get(response, "data.eventMessage.totalMonthlyStatement", 0);
        let totalAmountDue = 0;

        let dailyAuthTransmitted = null, dailyAuthPending = null;


        if (country !== "canada") {

          dailyAuthTransmitted = dailyStatements.filter((statement) => statement && statement.value && !this.isEmpty(statement.value.authStatus) && statement.value.authStatus.acceptanceErrorCode === ("A" || "Q11"));

          dailyAuthPending = dailyStatements.filter((statement) => {
            return statement && statement.value && this.isEmpty(statement.value.authStatus) || !statement.value.authStatus.acceptanceErrorCode || statement.value.authStatus.acceptanceErrorCode !== ("A" || "Q11")
          });

        }


        // if(isOps || isCustomer || isBroker) {
        //   if(this.state.auth && this.state.unauth) {
        //     dailyAuthTransmitted = dailyStatements;
        //     dailyAuthPending = [];
        //     authPending = [];
        //   } else if(this.state.unauth) {
        //     dailyAuthTransmitted = [];
        //   } else if(this.state.auth) {
        //     dailyAuthPending = [];
        //     authPending = [];
        //   } 
        // } 

        let prevAuthTransmitted = [];
        let prevAuthPending = [];
        let prevNewMonthlyStatements = [];

        if (apiCount == 1) {
          prevAuthTransmitted = [];
          prevAuthPending = [];
          prevNewMonthlyStatements = [];
        } else {
          prevAuthTransmitted = authTransmitted;
          prevAuthPending = authPending;
          prevNewMonthlyStatements = newMonthlyStatements;
        }
        this.setState({
          dailyStatements: country === "canada" ? [...(this.state.apiCount == 1 ? [] : this.state.dailyStatements), ...dailyStatements] : {
            authTransmitted: [...prevAuthTransmitted, ...(dailyAuthTransmitted)],
            authPending: [...prevAuthPending, ...(dailyAuthPending)],
            totalDailyData: [...prevAuthPending, ...(dailyAuthPending), ...prevAuthTransmitted, ...(dailyAuthTransmitted)],
          },
          monthlyStatements: country === "canada" ? monthlyStatements : [...prevNewMonthlyStatements, ...monthlyStatements],
          totalAmountDue: (totalAmountDue / 100).toFixed(2),
          isApiCallDone: true,
          isLoading: false,
          loadingState: false,
          apiCount: apiCount + 1,
          totalDailyStatement: totalDailyStatement,
          totalMonthlyStatement: totalMonthlyStatement,
          errorApiCount: 0,
          alertType: null,
          alertMsg: null
        });

        if (country === "canada") {
          if (dailyStatements.length === 0) {
            this.setState({ "lastPageReached": true })
            return;
          }
          else
            this.setState({ "lastPageReached": false })
        }


      } else if (!response.data.eventMessage.prelimStatements) {
        this.setState({
          loadingState: false,
          isLoading: false,
          isApiCallDone: true,
          errorApiCount: errorApiCount + 1,
        });
      }


      // this.setState({"toDateFilter": undefined, "fromDateFilter": undefined});
    } catch (err) {
      console.error(err);
      this.setState({
        loadingState: false,
        isLoading: false,
        isApiCallDone: true,
        apiError: true,
        errorApiCount: errorApiCount + 1,
      });
    }
  };

  setPun = (pun, i) => {
    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;
    let printStatement = !isEmpty(authPending) && isEmpty(authTransmitted) ? authPending : isEmpty(authPending) && !isEmpty(authTransmitted) ? authTransmitted : !isEmpty(authPending) && !isEmpty(authTransmitted) ? totalDailyData : [];

    let printStatementKey = !isEmpty(authPending) && isEmpty(authTransmitted) ? "authPending" : isEmpty(authPending) && !isEmpty(authTransmitted) ? "authTransmitted" : !isEmpty(authPending) && !isEmpty(authTransmitted) ? "totalDailyData" : [];

    let clonedStatement = cloneDeep(printStatement)
    clonedStatement[i].value.prelimStatements.punNumber = pun;

    this.setState({ dailyStatements: { ...this.state.dailyStatements, [printStatementKey]: clonedStatement } })
  }

  // handleAlertMessage = (alertType, statementNumber, values) => {
  //   this.setState({
  //     alertType,
  //     alertMsg: alertType === "success" ? "Entry(s) Deleted Successfully!" : "Something went wrong!, please try after sometime!"
  //   }, () => {
  //     this.reloadRecords(alertType, statementNumber, values)
  //   })
  // }

  // reloadRecords = (alertType, statementNumber, values) => {
  //   const copyOfStatements = {...this.state.dailyStatements}
  //   const authPending = copyOfStatements.authPending.find(ele => ele.key === statementNumber)
  //   const totalDailyData = copyOfStatements.totalDailyData.find(ele => ele.key === statementNumber);
  //   const updatedEnteries = authPending.value.prelimStatements.statementEntries.reduce((res, e1) => {
  //     values.map((e2) => {
  //       if(e2 === e1.entryNumber) {
  //         res.push({
  //           ...e1,
  //           isArchived: alertType === "success" ? true : false
  //         })
  //       }else{
  //         res.push(e1)
  //       }
  //     })
  //     return res;
  //   },[])
  //   authPending.value.prelimStatements.statementEntries = updatedEnteries;
  //   totalDailyData.value.prelimStatements.statementEntries = updatedEnteries;
  //   this.setState({
  //     alertType: null,
  //     alertMsg: null,
  //     dailyStatements: copyOfStatements
  //   })
  // }

  updateEntriesFromStatement = (entryNumberList, res, statementNumber, heading) => {

    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;
    // let printStatement = (authPending||[]).concat(authTransmitted||[]);
    console.log(authPending, "authTransmitted")

    let selectedStatemnet = heading === "Authorized" ? authTransmitted.filter(function (item) {
      return item.key === statementNumber
    }) : authPending.filter(function (item) {
      return item.key === statementNumber
    })

    if (res && res.data && res.data.eventMessage && res.data.eventMessage.entries.length > 0) {
      let respEntries = res.data.eventMessage.entries
      for (var i = 0; i < selectedStatemnet[0].value.prelimStatements.statementEntries.length; i++) {

        for (var j = 0; j < respEntries.length; j++) {
          if (respEntries[j].entryNumber === selectedStatemnet[0].value.prelimStatements.statementEntries[i].entryNumber) {
            if (selectedStatemnet[0].value.prelimStatements.statementEntries[i].hasOwnProperty("entryUpdateResp") === true) {
              selectedStatemnet[0].value.prelimStatements.statementEntries[i].entryUpdateResp.status = respEntries[j].status
            } else {
              let entryUpdateResp = {
                shipmentReleaseDate: respEntries[j].shipmentReleaseDate,
                periodicStatementMonth: respEntries[j].periodicStatementMonth,
                status: respEntries[j].status
              }
              selectedStatemnet[0].value.prelimStatements.statementEntries[i].entryUpdateResp = entryUpdateResp
            }

          }

        }
      }
      if (heading === "Authorized") {
        let replacingIndex = authTransmitted.findIndex(el => el.key === statementNumber)
        console.log(authTransmitted.findIndex(el => el.key === statementNumber), "insdex")
        authTransmitted[replacingIndex] = selectedStatemnet[0];

      } else {
        let index = authPending.findIndex(el => el.key === statementNumber)
        console.log(authPending.findIndex(el => el.key === statementNumber), "insdex")
        authPending[index] = selectedStatemnet[0];
      }


      let finalDaily = heading === "Authorized" ? authTransmitted : authPending
      console.log(finalDaily, "entryNumberList")
      this.setState(prevState => {
        let dailyStatements = Object.assign({}, prevState.dailyStatements);
        if (heading === "Authorized") {
          dailyStatements.authTransmitted = finalDaily
        } else {
          dailyStatements.authPending = finalDaily;
        }

        return { dailyStatements };
      })

    }
  }

  removeStamentFromList = (statementNumber, heading) => {

    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;


    let remaingStatemnet = heading === "Authorized" ? authTransmitted.filter(function (item) {
      return item.key !== statementNumber
    }) : authPending.filter(function (item) {
      return item.key !== statementNumber
    })


    console.log(remaingStatemnet, "selectedStatemnet")

    this.setState(prevState => {
      let dailyStatements = Object.assign({}, prevState.dailyStatements);
      if (heading === "Authorized") {
        dailyStatements.authTransmitted = remaingStatemnet
      } else {
        dailyStatements.authPending = remaingStatemnet;
      }

      return { dailyStatements };
    })

  }



  displayItems() {
    var items = [];
    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;
    let isBrokerKnAdmin =
      get(this.state, "kxUser.userBasicInfo.typeOfUser", "") ===
        "BROKER_KN_ADMIN" ? true : false
    let printStatement = (authPending || []).concat(authTransmitted || []);
    lastFilerCode = "";
    let startCounter = this.state.dailyPageCount * 10 - 10;
    let updateCounter = this.state.dailyPageCount * 10;
    // alert( !isEmpty(authPending)?"Pending":"Authorized" )
    lastHeading = "";

    for (var i = startCounter; i < updateCounter; i++) {
      if (!printStatement[i]) continue;
      var formattedDate = convertNumberStringToDate(printStatement[i].value.statementPrintDate);
      var currentFilerCode = printStatement[i].value.prelimStatements.filerCode;
      var reasonCode = printStatement[i].value.authStatus.reasonCode
      var isAuthorized = (reasonCode === "PAYMENT_AUTH_RESPONSE_ACCEPT") || (typeof reasonCode === "undefined" && printStatement[i].value.authStatus.acceptanceErrorCode === "A");
      if (isAuthorized) {
        heading = "Authorized";
      }
      else {
        heading = "Pending Authorization";
      }
      items.push(<React.Fragment>
        <h3 style={{ margin: "30px 0 5px" }}>
          {lastHeading !== heading ? heading : ""}
        </h3>
        {(lastDate !== formattedDate && this.state.groupBy === "date") ? <div className="stmtDate">{formattedDate}</div> : null}

        {(lastFilerCode !== currentFilerCode && this.state.groupBy === "filerCode") ?
          <div className="filerCodeWrapper">
            {isBroker ? null : <div className="stmtDate">{currentFilerCode}</div>}
            <div className="sortByDate" onClick={this.sortToggle.bind(this, currentFilerCode, i, printStatement)}>
              <Icon name='calendar alternate outline' link size='large' className="searchIcon" />
              <Icon name='sort content descending' link size='large' className="searchIcon" />
            </div>
          </div>
          : null}
        <PreDailyStatement isEngine={isEngine} getStatementData={this.getStatementData} filerCode={currentFilerCode} kxUser={get(this.state, "kxUser", {})} key={i} cbpDailyIndex={i} cbpDailyData={printStatement[i].value.prelimStatements} importerName={printStatement[i].value.prelimStatements.businessName}
          authStatus={printStatement[i].value.authStatus} statementPrintDate={printStatement[i].value.statementPrintDate} open={this.openDetail} fileName={printStatement[i].value.url} bucketName={printStatement[i].value.bucketName} statementNumber={printStatement[i].key} toggleModal={this.props.toggleModal}
          paymentStatusCode={printStatement[i].value.prelimStatements.paymentStatusCode} pun={printStatement[i].value.prelimStatements.punNumber} setPun={this.setPun} isBrokerKnAdmin={isBrokerKnAdmin} disabledArchiveButton={this.state.archived}
          updateEntriesFromStatement={this.updateEntriesFromStatement} heading={heading} nonArchiveEntries={printStatement[i].value.nonArchiveEntries} searchValue={this.state.searchValue} removeStamentFromList={this.removeStamentFromList}
          isDisabledFromEngine={getQueryVariable('isDisabledFromEngine') == 'true'?true:false}
        />
        {i == updateCounter - 1 && <p className="stmt_pixel"></p>}
      </React.Fragment>);
      lastDate = formattedDate;
      lastFilerCode = currentFilerCode;
      lastHeading = heading; 
    }
    lastDate = "";
    return items;
  }

  displayItemsCanada() {
    var items = [];
    // let { authPending } = this.state.dailyStatements;
    let { dailyStatements, groupBy, apiCount } = this.state;
    // console.log("ddd",dailyStatements)
    lastCustomer = "";
    lastDate = "";

    let startCounter = 0;
    let updateCounter = apiCount * 20;
    let filerCode =  get(this.state, "kxUser.userInfo.brokerAdditionalInfo.filerCode") || get(this.state, "kxUser.userInfo.brokerAdditionalInfo.accountSecurityNumber", "");
    for (var i = startCounter; i < updateCounter; i++) {

      items.push(<React.Fragment key={i}>
        {(dailyStatements[i] && (lastDate !== dailyStatements[i].DN_DATE) && this.state.groupBy === "DATE") ? <div className="stmtDate">{this.changeIsoToKnFormat(dailyStatements[i].DN_DATE)}</div> : null}

        {(dailyStatements[i] && (lastCustomer !== dailyStatements[i].importerName) && this.state.groupBy === "CUSTOMER") ? <div className="stmtDate">{dailyStatements[i].importerName}</div> : null}

        {dailyStatements[i] && <PreDailyStatementCanada filerCode={filerCode} kxUser={get(this.state, "kxUser", {})} key={i} cbpDailyIndex={i} importerName={dailyStatements[i].importerName} k84Date={this.changeIsoToKnFormat(dailyStatements[i].DN_DATE)} amount={dailyStatements[i].b3nTotal_due} cbpDailyData={dailyStatements[i]} fileName={"dailyStatements[i].value.url"} bucketName={"dailyStatements[i].value.bucketName"} groupBy={groupBy} />}

        {i == updateCounter - 39 && <p class="stmt_pixel"></p>}

      </React.Fragment>);

      lastDate = dailyStatements[i] ? dailyStatements[i].DN_DATE : "";
      lastCustomer = dailyStatements[i] ? dailyStatements[i].importerName : "";
    }
    lastDate = "";
    lastCustomer = "";
    return items;
  }

  monthlyDisplayItems() {
    var items = [];
    let { counter, monthlyStatements } = this.state;
    // if(monthlyStatements.length === 1 && typeof monthlyStatements[0] == "undefined" )
    //   delete monthlyStatements[0];
    lastFilerCode = "";
    formattedDate = "";

    let startCounter = this.state.monthlyPageCount * 10 - 10;
    let updateCounter = this.state.monthlyPageCount * 10;

    for (var i = startCounter; i < updateCounter; i++) {
      if (!monthlyStatements[i]) continue;

      if (typeof monthlyStatements[i] == "undefined")
        continue;

      var formattedDate = convertNumberStringToDate(monthlyStatements[i].value.statementPrintDate);
      var currentFilerCode = get(this.state, "kxUser.userInfo.brokerAdditionalInfo.filerCode") || get(this.state, "kxUser.userInfo.brokerAdditionalInfo.accountSecurityNumber", "");

      items.push(
        <React.Fragment>
          {(lastDate !== formattedDate && this.state.groupBy === "date") ? <div className="stmtDate">{formattedDate}</div> : null}

          {(lastFilerCode !== currentFilerCode && this.state.groupBy === "filerCode") ?
            <div className="filerCodeWrapper">
              {isBroker ? null : <div className="stmtDate">{currentFilerCode}</div>}
              <div className="sortByDate" onClick={this.sortToggle.bind(this, currentFilerCode, i, monthlyStatements)}>
                <Icon name='calendar alternate outline' link size='large' className="searchIcon" />
                <Icon name='sort content descending' link size='large' className="searchIcon" />
              </div>
            </div> : null}

          <MonthlyStatement country={this.state.country} usersCountry={this.state.usersCountry} filerCode={currentFilerCode} kxUser={get(this.state, "kxUser", {})} key={i} cbpDailyIndex={i} cbpDailyData={monthlyStatements[i].value.prelimStatements} importerName={monthlyStatements[i].value.prelimStatements.businessName} authStatus={monthlyStatements[i].value.authStatus} statementPrintDate={monthlyStatements[i].value.statementPrintDate} fileName={monthlyStatements[i].value.url} bucketName={monthlyStatements[i].value.bucketName} />
          {(i + 1) % 10 === 0 && <p className="stmt_pixel"></p>}
        </React.Fragment>
      );

      lastDate = formattedDate;
      lastFilerCode = currentFilerCode;
    }
    return items;
  }

  loadMoreItems(nav = "next") {


    const { counter, typeSelected, monthlyStatements, totalDailyStatement, totalMonthlyStatement, isApiCallDone, errorApiCount, dailyPageCount, monthlyPageCount } = this.state;

    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;

    let statement = typeSelected === "DAILY" && !isEmpty(authPending) && isEmpty(authTransmitted) ? authPending : isEmpty(authPending) && !isEmpty(authTransmitted) ? authTransmitted : !isEmpty(authPending) && !isEmpty(authTransmitted) ? totalDailyData : monthlyStatements

    const totalList = typeSelected === "DAILY" ? totalDailyStatement : totalMonthlyStatement;

    if (this.state.country === "canada") {
      statement = typeSelected === "DAILY" ? this.state.dailyStatements : null;
    }
    if (counter < totalList) {
      if (typeSelected === "DAILY" ? (dailyPageCount % 10 > 0) : (monthlyPageCount % 10 > 0)) {
        const diff = statement.length / pageSize;
        const [totalSize, fraction] = [+diff.toString().split(".")[0], +diff.toString().split(".")[1]];
        const totalItemVal = totalSize * pageSize;
        if (this.state.loadingState) {
          return;
        }
        this.setState({ loadingState: true });

        if (counter < totalItemVal) {
          let size = counter + pageSize > statement.length ? statement.length : counter + pageSize;
          setTimeout(() => {
            this.setState({ counter: size, loadingState: false });
          }, 100);
        } else {
          let size = counter + fraction > statement.length ? statement.length : counter + fraction;
          setTimeout(() => {
            this.setState({ counter: size, loadingState: false });
          }, 100);
        }
      } else {
        if (isApiCallDone && errorApiCount < 2 && totalList > 100) {
          // this.setState(prevState  => ({ apiCount: prevState.apiCount+1 }), 
          // () => { this.getStatementData(true) }); 
          this.getStatementData();
          // this.setState({ loadingDone: true });
        }
        if (errorApiCount > 2) {
          this.setState({ apiError: true, loadingState: false, loadingDone: true });
        }
      }
    } else {
      this.setState({ loadingDone: true, loadingState: false, apiError: true });
    }
  }

  loadMoreItemsCanada(nav = "next") {

    const { typeSelected, monthlyStatements } = this.state;

    let { authPending, authTransmitted, totalDailyData } = this.state.dailyStatements;

    let statement = typeSelected === "DAILY" && !isEmpty(authPending) && isEmpty(authTransmitted) ? authPending : isEmpty(authPending) && !isEmpty(authTransmitted) ? authTransmitted : !isEmpty(authPending) && !isEmpty(authTransmitted) ? totalDailyData : monthlyStatements

    if (this.state.country === "canada") {
      statement = typeSelected === "DAILY" ? this.state.dailyStatements : null;
    }
    if (!this.state.lastPageReached)
      this.getStatementData();
  }

  //called when daily/monthly tabs are switched
  searchInvoice = async (count = 1, typeClicked = 'DAILY', lastTypeClicked) => {
    
    const {
      errorApiCount,
      searchValue,
      apiCount,
      country
    } = this.state;

    try {

      this.setState({ loadingState: true, loadingDone: false, searchError: false, isApiCallDone: false, searchLoading: true, isLoading: false, dailyPageCount: 1 });



      let eventId = get(this.state, "kxUser.userBasicInfo.userGuid", "");
      var currentFilerCode = get(this.state, "kxUser.userInfo.brokerAdditionalInfo.filerCode") || get(this.state, "kxUser.userInfo.brokerAdditionalInfo.accountSecurityNumber", "");

      let response = await accountAPI.getDailyPreAuth(currentFilerCode, count, searchValue, this.state, undefined, eventId, isEngine);

      this.setState({
        totalSima: get(response, "data.eventMessage.totalSima", 0),
        totalExcise: get(response, "data.eventMessage.totalExcise", 0),
        totalDuties: get(response, "data.eventMessage.totalDuties", 0),
        totalGST: get(response, "data.eventMessage.totalGST", 0),
        totalPenalty: get(response, "data.eventMessage.totalPenalty", 0),
        totalInterest: get(response, "data.eventMessage.totalInterest", 0),
        grandTotal: get(response, "data.eventMessage.GrandTotal", 0),
        usersCountry: get(response, "data.eventMessage.country", "")
      });

      if (Object.keys(response.data.eventMessage).length === 0 ||
        (!response.data.eventMessage.totalStatements &&
          !response.data.eventMessage.totalDailyStatement &&
          !response.data.eventMessage.totalMonthlyStatement)) {
        response.data.eventMessage = {
          dailyStatementDetails: [],
          monthlyStatementDetails: [],
          totalStatements: 0,
          totalDailyStatement: 0,
          totalMonthlyStatement: 0
        };

      }

      let dStatements, mStatements;
      if (response.data.eventMessage.statements) {
        dStatements = [];
        mStatements = [];
        for (let i = 0; i < response.data.eventMessage.statements.length; i++) {
          dStatements.push(response.data.eventMessage.statements[i].value.dailyStatementDetails);
          mStatements.push(response.data.eventMessage.statements[i].value.monthlyStatementDetails);
        }
        dStatements = dStatements.flat();
        mStatements = mStatements.flat();
      }
      //if(((isOps || isCustomer) && (this.state.auth || (this.state.auth && this.state.unauth))) ) {
      else {
        dStatements = response.data.eventMessage.dailyStatementDetails;
        mStatements = response.data.eventMessage.monthlyStatementDetails;
      }

      if (dStatements || mStatements) {
        let dailyStatements = dStatements ? dStatements : [];
        let monthlyStatements = mStatements ? mStatements : [];
        let totalDailyStatement = get(response, "data.eventMessage.totalDailyStatement", 0);
        let totalMonthlyStatement = get(response, "data.eventMessage.totalMonthlyStatement", 0);
        let totalAmountDue = 0;

        let dailyAuthTransmitted = null, dailyAuthPending = null;


        if (country !== "canada") {

          dailyAuthTransmitted = dailyStatements.filter((statement) => statement && statement.value && !this.isEmpty(statement.value.authStatus) && statement.value.authStatus.acceptanceErrorCode === ("A" || "Q11"));

          dailyAuthPending = dailyStatements.filter((statement) => {
            return statement && statement.value && this.isEmpty(statement.value.authStatus) || !statement.value.authStatus.acceptanceErrorCode || statement.value.authStatus.acceptanceErrorCode !== ("A" || "Q11")
          });

        }

        // let dailyAuthTransmitted = dailyStatements.filter((statement) => statement && statement.value && !this.isEmpty(statement.value.authStatus));
        // let dailyAuthPending = dailyStatements.filter((statement) => statement && statement.value && this.isEmpty(statement.value.authStatus));

        this.setState({
          // dailyStatements: country==="canada"?dailyStatements:{
          //   authTransmitted: [...prevAuthTransmitted, ...this.sortData(dailyAuthTransmitted)],
          //   authPending: [...prevAuthPending, ...this.sortData(dailyAuthPending)],
          // },
          // monthlyStatements: country==="canada"?monthlyStatements:[...prevNewMonthlyStatements, ...monthlyStatements],
          dailyStatements: country === "canada" ? dailyStatements : {
            authTransmitted: (dailyAuthTransmitted),
            authPending: (dailyAuthPending),
          },
          monthlyStatements: country === "canada" ? monthlyStatements : monthlyStatements,
          totalAmountDue: (totalAmountDue / 100).toFixed(2),
          isApiCallDone: true,
          isLoading: false,
          loadingState: false,
          errorApiCount: 0,
          searchLoading: false,
          loadingDone: false,
          searchError: false,
        });


        if (apiCount === 1 || totalDailyStatement > 0 || totalMonthlyStatement > 0) {
          this.setState({
            totalDailyStatement: totalDailyStatement,
            totalMonthlyStatement: totalMonthlyStatement
          });
        }

        if (typeClicked === "DAILY" && lastTypeClicked === "MONTHLY") {
          this.setState({ apiCount: this.state.apiCount + 1 })
        }



      } else {
        this.setState({
          loadingState: false,
          isLoading: false,
          isApiCallDone: true,
          errorApiCount: errorApiCount + 1,
          searchLoading: false,
          loadingDone: false,
          searchError: true,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        loadingState: false,
        isLoading: false,
        isApiCallDone: true,
        apiError: true,
        errorApiCount: errorApiCount + 1,
        searchLoading: false,
        searchError: false,
      });
    }
  };

  nextPage = () => {
    const { totalDailyStatement, totalMonthlyStatement } = this.state;

    if (this.state.typeSelected === "DAILY")
      this.setState(prevState => ({
        dailyPageCount: (prevState.dailyPageCount + 1) > Math.ceil(totalDailyStatement / 10) ? prevState.dailyPageCount : prevState.dailyPageCount + 1,
        nav: "next"
      }),
        () => this.loadMoreItems("next"));
    else
      this.setState(prevState => ({
        monthlyPageCount: (prevState.monthlyPageCount + 1) > Math.ceil(totalMonthlyStatement / 10) ? prevState.monthlyPageCount : prevState.monthlyPageCount + 1,
        nav: "next"
      }),
        () => this.loadMoreItems("next"));
  }

  prevPage = () => {
    if (this.state.typeSelected === "DAILY")
      this.setState(prevState => ({
        dailyPageCount: (prevState.dailyPageCount - 1) < 1 ? prevState.dailyPageCount : prevState.dailyPageCount - 1,
        nav: "prev"
      }),
        () => this.loadMoreItems("prev"));
    else
      this.setState(prevState => ({
        monthlyPageCount: (prevState.monthlyPageCount - 1) < 1 ? prevState.monthlyPageCount : prevState.monthlyPageCount - 1,
        nav: "prev"
      }),
        () => this.loadMoreItems("prev"));
  }

  searchInputChange = (event) => {
    const value = event.clipboardData ? event.clipboardData.getData('Text') : event.target.value;
    this.setState({ searchValue: value });
  };

  onSubmitEvent = () => {
    const { loadingState, searchValue } = this.state;
    if (!loadingState && !isEmpty(searchValue)) {

      this.searchInvoice()
    }
  }

  onSearchEvent = () => {
    const { loadingState, searchValue } = this.state;
    if (!loadingState && !isEmpty(searchValue)) {
      this.searchInvoice();
    }
  };

  keyUp = (event) => {
    const { loadingState } = this.state;
    if (event.keyCode == 13 || event.target.value === "") {
      // this.setState({ showingAdvancedSearch: false });
      this.setState({ searchValue: event.target.value }, () => {
        if (!loadingState) {
          this.searchInvoice();
        }
      });
    }
  };

  authUnauthChanged = (e, { value }) => {
    this.setState({ dailyPageCount: 1, monthlyPageCount: 1 })
    if (value === "auth") {

      if (this.state.auth && !this.state.unauth) {
        return;
      }

      this.setState({ auth: this.state.auth ? false : true, archived: false, apiCount: 1, counter: pageSize }, () => {
        this.getStatementData();

        if (this.state.unauth && this.state.auth)
          this.setState({ "groupBy": "date" });

        else if (this.state.unauth)
          this.setState({ "groupBy": "filerCode" });

        else if (this.state.auth)
          this.setState({ "groupBy": "date" });

      });

    } else if (value === "archived") {
      this.setState({ auth: false, unauth: false, archived: true, apiCount: 1, counter: pageSize }, () => {
        this.getStatementData();

      });
    }
    else {

      if (this.state.unauth && !this.state.auth) {
        return;
      }

      this.setState({ unauth: this.state.unauth ? false : true, archived: false, apiCount: 1, counter: pageSize }, () => {
        this.getStatementData();

        if (this.state.unauth && this.state.auth)
          this.setState({ "groupBy": "date" });

        else if (this.state.unauth)
          this.setState({ "groupBy": "filerCode" });

        else if (this.state.auth)
          this.setState({ "groupBy": "date" });

      });

    }
  };

  onDropDownEvent = () => {
    this.setState({ showDropDown: this.state.showDropDown ? false : true });
  }

  groupByChange = (e, { value }) => {
    this.setState({ groupBy: value });
  }

  brokerFilerFilterChanged = (e) => {
    this.setState({ brokerFilerFilter: e.target.value });
  }

  transactionNoFilterChanged = (e) => {
    this.setState({ transactionNoFilter: e.target.value });
  }

  poFilterChanged = (e) => {
    this.setState({ poFilter: e.target.value });
  }

  portFilterChanged = (e) => {
    this.setState({ portFilter: e.target.value });
  }

  sortToggle = (filerCode, index, statements) => {

    this.setState({ searchLoading: true });
    let filerCodeEnd = index;
    for (let i = index; i < statements.length; i++) {
      if (statements[i].value.prelimStatements.filerCode == filerCode)
        filerCodeEnd = i;
    }
    let limit;
    if ((filerCodeEnd - index) % 2 === 0)
      limit = (filerCodeEnd - index) / 2 - 1;
    else
      limit = (filerCodeEnd - index) / 2;

    for (let i = index; i < limit; i++) {
      let temp = statements[i];
      statements[i] = statements[filerCodeEnd - i];
      statements[filerCodeEnd - i] = temp;
    }

    this.setState({ searchLoading: false });
  }


  applyClickedCanada = () => {

    const { toDateFilter, fromDateFilter, poFilter, portFilter, transactionNoFilter } = this.state;

    if (!fromDateFilter || !toDateFilter)
      this.setState({ errorMsg: "Please fill both of the dates" })
    else {
      this.setState({ appliedFromDate: this.state.fromDateFilter });
      this.setState({ appliedToDate: this.state.toDateFilter });


      this.setState({ showingAdvancedSearch: true, errorMsg: "", toDateMsg: "", fromDateMsg: "", apiCount: 1, searchApplied: true }, () => {
        this.getStatementData()
        this.setState({ showDropDown: false });
      })

    }
  }


  applyClicked = () => {

    if (!this.state.fromDateFilter)
      this.setState({ fromDateMsg: "Please fill the date", toDateMsg: "" })
    else if (!this.state.toDateFilter)
      this.setState({ toDateMsg: "Please fill the date", fromDateMsg: "" })
    else {
      this.setState({ appliedFromDate: this.state.fromDateFilter, appliedToDate: this.state.toDateFilter, showingAdvancedSearch: true, toDateMsg: "", fromDateMsg: "", apiCount: 1, searchApplied: true }, () => {
        this.getStatementData()
        this.setState({ showDropDown: false });
      })

    }
  }


  resetAdvancedSearch = (showSearchDropDown = false) => {

    this.setState({
      appliedFromDate: this.whichCountry() === "canada" ? this.state.fromDateFilter : "",
      appliedToDate: this.whichCountry() === "canada" ? this.state.toDateFilter : "",
      fromDateMsg: "",
      toDateMsg: "",
      showingAdvancedSearch: false,
      fromDateFilter: this.whichCountry() === "canada" ? defaultStartDate : undefined,
      toDateFilter: this.whichCountry() === "canada" ? defaultEndDate : undefined,
      poFilter: undefined,
      portFilter: undefined,
      transactionNoFilter: undefined,
      apiCount: 1,
      showDropDown: false,
      searchApplied: false
    }, () => {
      if (showSearchDropDown)
        this.setState({ showDropDown: true });

      this.getStatementData();
      this.forceUpdate();
    });
  }

  showAdvancedSearchString = () => {
    let string = this.state.showingAdvancedSearch &&
      (<strong>
        Statements from {moment(new Date(this.state.appliedFromDate)).format('MMMM Do YYYY')}&nbsp;
        to {moment(new Date(this.state.appliedToDate)).format('MMMM Do YYYY')}.
        &nbsp;<a className="resetSearch" onClick={() => this.resetAdvancedSearch(false)}>Reset</a>
      </strong>);

    return string;
  }

  groupByChange = (value) => {
    this.setState({ groupBy: value, apiCount: 1 }, () => {
      this.getStatementData()
    })
  }

  formatDate = (date) => {
    if (!(date instanceof Date && !isNaN(date))) //if invalid date
      return <span style={{ color: "#ccc" }}>MM/DD/YYYY</span>;

    if (this.whichCountry() === "canada")
      return this.changeIsoToKnFormat(`${date.getFullYear()}-${this.pad(date.getMonth() + 1, 2)}-${this.pad(date.getDate(), 2)}`, true);
    else
      return `${date.getFullYear()}-${this.pad(date.getMonth() + 1, 2)}-${this.pad(date.getDate(), 2)}`
  }

  pad = (num, size) => { //add leading zeros
    var s = "000000000" + num;
    return s.substr(s.length - size);
  }

  render() {
    let { totalDailyStatement, totalMonthlyStatement, dailyStatements, isLoading, typeSelected, country, loadingState, loadingDone, searchError, searchValue, searchLoading, dailyPageCount, monthlyPageCount, totalSima, totalExcise, totalDuties, totalGST, totalPenalty, totalInterest, grandTotal, cob, searchApplied, fromDateFilter, toDateFilter } = this.state;
    let dailyStatementCount = totalDailyStatement;
    let monthlyStatementsCount = totalMonthlyStatement;

    const groupByOptions = [
      { key: 'none', text: 'None', value: 'NONE' },
      { key: 'customer', text: 'Customer', value: 'CUSTOMER' },
      { key: 'date', text: 'Date', value: 'DATE' }
    ];

    let classNames = "";
    if (this.state.country === "canada") {
      classNames += " isCanadaStatements ";
    } else {
      classNames += " isOtherStatements ";
    }
    if (typeSelected === "DAILY" || typeSelected === "MONTHLY") {
      classNames += " daily-container ";
    }

    if (searchApplied || searchValue) {
      classNames += " searchIsOn ";
    }

    let { authTransmitted, authPending } = dailyStatements

    const { toggleModal, toggle } = this.props

    return (
      <div id={this.state.statementClass} className={`${classNames} outer-modal-container`}>
        {searchLoading ? (
          <p
            className='loading'
            style={{
              textAlign: 'center',
              fontSize: '20px',
              position: 'absolute',
              left: '650px',
              top: '10px',
              zIndex: 1,
            }}
          >
            {!isEmpty(searchValue)
              ? 'Loading search results...'
              : 'Loading initial state'}
          </p>
        ) : null}

        <PreDailyHeader
          isLoading={isLoading}
          typeSelected={typeSelected}
          setCountry={this.setCountry}
          setStatementType={this.setStatementType}
          monthlyStatementCount={monthlyStatementsCount}
          dailyStatementCount={dailyStatementCount}
          totalAmountDue={this.state.totalAmountDue}
          cob={this.whichCountry()}
        />

        <div className='statementsBar'>
          {this.props.statmentSelctedFromKlearView !== '' && (
            <div
              style={{
                float: 'left',
                display: 'flex',
                color: '#285D81',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
              onClick={() => {
                console.log(this.props, 'props');
                toggleModal('');
                let hamburger = document.getElementById('kn-hamberger-opened');
                hamburger.click();
                let KlearViewBtn = document.getElementById('KlearViewBtn');
                KlearViewBtn.click();
              }}
            >
              {' '}
              { !isEngine && <><Icon name='arrow left' /> <div>Back To KlearView</div></> }
            </div>
          )}
          {/* <h1>Statements</h1> */}
          {String(this.state.appliedFromDate) !== 'Invalid date' &&
            this.state.appliedFromDate && (
              <span className='date_start'>
                <span className='label'>Start Date:</span>
                {/* <DateInputField
              id="stmtFromDate"
              width={6}
              value={this.state.appliedFromDate}
              
              disabled
            /> */}
                <div id='stmtFromDate'>
                  {this.formatDate(this.state.appliedFromDate)}
                </div>
              </span>
            )}
          {String(this.state.appliedToDate) !== 'Invalid date' &&
            this.state.appliedToDate && (
              <span className='date_end'>
                <span className='label'>End Date:</span>
                {/* <DateInputField
              id="stmtToDate"
              width={6}
              value={this.state.appliedToDate}
            
              disabled
            /> */}
                <div id='stmtToDate'>
                  {this.formatDate(this.state.appliedToDate)}
                </div>
              </span>
            )}

          {
            (['CA', "CANADA"].includes(window.shipmentCountry?.toUpperCase()) || (isEngine && enginePaymentCountry === 'ca'))
            &&
            <span className='label'>
              <Button
                style={{ position: "relative", bottom: 7, marginLeft: 10 }}
                key={`closeModal-${Math.random()}`}
                // className={'add-line-item-btn rectangle'}
                basic
                // color='blue'
                circular
                compact
                onClick={() => this.setState({ open: true })}
              >
                Monthly Statement
              </Button>
              <MonthlyModal
                open={this.state.open}
                setClose={() => this.setState({ open: false })}
              />
            </span>
          }


          <div className='group_by'>
            <label>Group by:</label>
            <div className='group_by_dropdown'>
              <Dropdown
                lazyLoad={true}
                fluid
                selection
                options={groupByOptions}
                onChange={(e, data) => this.groupByChange(data.value)}
                defaultValue={'NONE'}
              />
            </div>
          </div>

          <div className='ui action input searchBox' style={{ float: 'left' }}>
            <Icon name='search' link className='searchIcon' />
            <input
              type='text'
              placeholder='Search statements...'
              id='searchInputBox'
              value={searchValue}
              onKeyUp={this.keyUp}
              onChange={this.searchInputChange}
            />
            <Icon
              name='angle down'
              link
              size='large'
              className='arrowIcon'
              onClick={this.onDropDownEvent}
            />

            {this.state.showDropDown && (
              <div className='advancedSearchDropDown'>
                <label
                  className='labelHeading'
                  style={{ marginBottom: '15px' }}
                >
                  Advanced Search
                </label>

                {!isBroker && (
                  <div className='brokerBox'>
                    <label className='brokerLabel'>
                      Broker name or Filer code
                    </label>
                    <input
                      type='text'
                      className='brokerInput'
                      value={this.state.brokerFilerFilter}
                      onChange={this.brokerFilerFilterChanged}
                    />
                  </div>
                )}

                <div className='formRow dateRow'>
                  <DateInputField
                    id='fromDate'
                    label='Start Date'
                    width={6}
                    dateFormat='MMM DD, YYYY'
                    value={fromDateFilter}
                    onChange={(value) => {
                      this.setState({ fromDateFilter: value });
                      if (!this.state.toDateFilter) {
                        this.setState({
                          toDateFilter: moment(value).add(1, 'days'),
                        });
                      }
                    }}
                  />
                  {/* <p className="errorMessage">{this.state.fromDateMsg}</p> */}

                  <DateInputField
                    id='toDate'
                    label='End Date'
                    width={6}
                    dateFormat='MMM DD, YYYY'
                    value={toDateFilter}
                    onChange={(value) => {
                      this.setState({ toDateFilter: value });
                      if (!this.state.fromDateFilter) {
                        this.setState({
                          fromDateFilter: moment(value).subtract(1, 'days'),
                        });
                      }
                    }}
                  />
                </div>

                {/* <div className="formRow">
                  <input 
                      type="text" 
                      className="" 
                      value={this.state.brokerFilerFilter} 
                      onChange={ this.brokerFilerFilterChanged }
                    />

                  <input 
                      type="text" 
                      className="" 
                      value={this.state.brokerFilerFilter} 
                      onChange={ this.brokerFilerFilterChanged }
                  />

                </div> */}
                {/* <p className="errorMessage">{this.state.toDateMsg}</p> */}

                {country === 'canada' && (
                  <div className='formRow formRowTwoChildren'>
                    <div className='brokerBox'>
                      <label className='brokerLabel'>PO</label>
                      <input
                        type='text'
                        className='brokerInput'
                        value={this.state.poFilter}
                        onChange={this.poFilterChanged}
                      />
                    </div>
                    <div className='brokerBox'>
                      <label className='brokerLabel'>Port</label>
                      <input
                        type='text'
                        className='brokerInput'
                        value={this.state.portFilter}
                        onChange={this.portFilterChanged}
                      />
                    </div>
                  </div>
                )}

                {country === 'canada' && (
                  <div className='formRow'>
                    <div className='brokerBox'>
                      <label className='brokerLabel'>Transaction Number</label>
                      <input
                        type='text'
                        className='brokerInput'
                        value={this.state.transactionNoFilter}
                        onChange={this.transactionNoFilterChanged}
                      />
                    </div>
                  </div>
                )}
                <p style={{ color: 'red' }}>{this.state.errorMsg}</p>
                <Button
                  className='advancedSearchApply'
                  onClick={
                    this.whichCountry() === 'canada'
                      ? this.applyClickedCanada
                      : this.applyClicked
                  }
                >
                  Apply
                </Button>

                <Button
                  className='advancedSearchReset'
                  onClick={(e) => this.resetAdvancedSearch(true, e)}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
          {typeSelected === 'DAILY' && country !== 'canada' && (
            <>
              {this.state.unauth ? (
                <Icon
                  name='check square outline'
                  onClick={this.authUnauthChanged}
                  value='unauth'
                  link
                  size='large'
                  className='searchIcon unauth_checked'
                />
              ) : (
                <Icon
                  name='square outline'
                  link
                  size='large'
                  onClick={this.authUnauthChanged}
                  value='unauth'
                  className='searchIcon unauth_empty'
                />
              )}

              <Checkbox
                label='Pending'
                checked={this.state.unauth === true}
                onChange={this.authUnauthChanged}
                name='unauth'
                value='unauth'
                className='pending_checkbox'
              />

              {this.state.auth ? (
                <Icon
                  name='check square outline'
                  onClick={this.authUnauthChanged}
                  value='auth'
                  link
                  size='large'
                  className='searchIcon auth_checked'
                />
              ) : (
                <Icon
                  name='square outline'
                  link
                  size='large'
                  onClick={this.authUnauthChanged}
                  value='auth'
                  className='searchIcon auth_empty'
                />
              )}

              <Checkbox
                label='Authorized'
                checked={this.state.auth === true}
                onChange={this.authUnauthChanged}
                name='auth'
                value='auth'
              />
              {this.state.archived ? (
                <Icon
                  name='check square outline'
                  onClick={this.authUnauthChanged}
                  value='archived'
                  link
                  size='large'
                  className='searchIcon auth_checked'
                />
              ) : (
                <Icon
                  name='square outline'
                  link
                  size='large'
                  onClick={this.authUnauthChanged}
                  value='archived'
                  className='searchIcon auth_empty'
                />
              )}

              <Checkbox
                label='Archive'
                checked={this.state.archived === true}
                onChange={this.authUnauthChanged}
                name='archived'
                value='archived'
              />
            </>
          )}

          <Button
            id='searchStatementButton'
            style={{ visibility: 'hidden' }}
            onClick={(e) => {
              e.stopPropagation();
              this.onSubmitEvent();
            }}
          >
            Submit
          </Button>
        </div>

        {/* {counter + get(dailyStatements, "authTransmitted", []).length > 0 && 
         typeSelected === "DAILY" && (
          <p style={{ textAlign: "center", position: "fixed", zIndex: 1, background: "#f5f5f5", width: "100%", left: 0, padding: "5px", marginTop: "9px" }} className="amites">
            Showing {counter + dailyStatements.authTransmitted.length > dailyStatements.authTransmitted.length + dailyStatements.authPending.length ? dailyStatements.authTransmitted.length + dailyStatements.authPending.length : dailyStatements.authTransmitted.length + counter} of {dailyStatementCount}{" "}
          </p>
        )}

        {monthlyStatements.length && typeSelected === "MONTHLY" && (
          <p style={{ textAlign: "center", position: "fixed", zIndex: 1, background: "#f5f5f5", width: "100%", left: 0, padding: "5px", marginTop: "9px" }}>
            Showing {counter > monthlyStatements.length ? monthlyStatements.length : counter} of {monthlyStatementsCount}{" "}
          </p>
        )}
         */}
        <div className='section-container' ref='iScroll'>
          {isLoading ? (
            <div className='loaderDiv'>
              <Dimmer
                active
                inverted
                style={{
                  background: 'transparent',
                  width: '20vh',
                  marginLeft: '200px',
                }}
              >
                <Loader style={{ background: 'transparent' }} size='medium'>
                  Loading
                </Loader>
              </Dimmer>
            </div>
          ) : typeSelected === 'MONTHLY' && totalMonthlyStatement > 0 ? (
            <div className='statementsDiv'>
              {this.showAdvancedSearchString()}
              {totalMonthlyStatement > 0 ? (
                this.monthlyDisplayItems()
              ) : (
                <center>No statements pending </center>
              )}
              {/* {loadingState ? (
                <p className="loading" style={{ textAlign: "center", fontSize: "20px" }}>
                  {" "}
                  Loading Statements...
                </p>
              ) : null} */}
              {loadingDone ? (
                <p
                  className='loading'
                  style={{ textAlign: 'center', fontSize: '20px' }}
                >
                  {' '}
                </p>
              ) : null}
              {searchError ? (
                <p
                  className='loading'
                  style={{ textAlign: 'center', fontSize: '20px' }}
                >
                  No search results found{' '}
                </p>
              ) : null}
            </div>
          ) : country === 'canada' ? (
            <div className='statementsDiv'>
              {/* {console.log("states",dailyStatements)} */}
              {dailyStatements && dailyStatements.length > 0 ? (
                this.displayItemsCanada()
              ) : (
                <center>No statements to show here </center>
              )}

              {/* <button onClick={() => this.loadMoreItemsCanada()}>Load more</button> */}

              {loadingState ? (
                <div className='loaderDiv'>
                  <center>Loading...</center>
                </div>
              ) : null}
            </div>
          ) : typeSelected === 'DAILY' &&
            ((authPending && authPending.length) > 0 ||
              (authTransmitted && authTransmitted.length > 0)) ? (
            <div className='statementsDiv'>
              <div
                style={{ float: 'left', width: '100%' }}
                className='statementsDivChild'
              >
                {this.showAdvancedSearchString()}
                {/* { isBroker && this.state.auth && this.state.unauth ?
                  <h3 style={{ margin: "30px 0 5px" }}>Pending Authorization</h3> : null
                }   */}

                {!isEmpty(authPending) && isEmpty(authTransmitted) ? (
                  this.displayItems()
                ) : (
                  <center></center>
                )}

                {/* {
                  this.state.alertMsg && 
                  <div className="delete-alert">
                    <Message color={this.state.alertType === "success" ? "green" : "red"}>{this.state.alertMsg}</Message>
                  </div>
                }

                { !isEmpty(authPending) && isEmpty(authTransmitted) && this.state.alertMsg === null ? this.displayItems() : null} */}

                {loadingDone ? (
                  <p
                    className='loading'
                    style={{ textAlign: 'center', fontSize: '20px' }}
                  >
                    {' '}
                  </p>
                ) : null}
                {searchError ? (
                  <p
                    className='loading'
                    style={{ textAlign: 'center', fontSize: '20px' }}
                  >
                    No search result found{' '}
                  </p>
                ) : null}
              </div>
              <div>
                {/* {
                  isBroker && this.state.auth && this.state.unauth &&
                  <h3 style={{ marginTop: "35px", marginBottom: "5px", clear: "left", paddingTop: "22px" }}>Authorized</h3>
                } */}
                {authTransmitted && authTransmitted.length > 0
                  ? this.displayItems()
                  : null}
                {/* {authTransmitted && authTransmitted.length > 0 && this.state.alertMsg === null ? this.displayItems() : null} */}
                {authTransmitted &&
                  authTransmitted.length > 0 ? null : loadingState ? (
                    <div className='loaderDiv'>
                      <center>Loading...</center>
                    </div>
                  ) : (
                  ''
                )}
              </div>
            </div>
          ) : (
            <div>
              {this.showAdvancedSearchString()}
              {!loadingState && (
                <div
                  className='statementsDiv'
                  style={{
                    marginTop: '30vh',
                    textAlign: 'center',
                  }}
                >
                  No Record Found.
                </div>
              )}
            </div>
          )}
        </div>
        {country === 'canada' && (
          <div className='summaryTable'>
            <table>
              <tr>
                <td></td>
                <td>Duties</td>
                <td>SIMA</td>
                <td>EXCISE</td>
                <td>GST</td>
                <td>PENALTY</td>
                <td>INTEREST</td>
                <td>GRAND TOTAL</td>
              </tr>

              <tr>
                <td>
                  <div className='no-highlight'>GRAND TOTAL:</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalDuties)}</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalSima)}</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalExcise)}</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalGST)}</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalPenalty)}</div>
                </td>
                <td>
                  <div>C$ {this.formatAmount(totalInterest)}</div>
                </td>
                <td>
                  <div className='highlightTotal'>
                    C$ {this.formatAmount(grandTotal)}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        )}

        {this.whichCountry() !== 'canada' && (
          <div className='pagination'>
            {country === 'canada' &&
              typeSelected === 'DAILY' &&
              dailyStatements.length === 0 ? null : (
              <>
                <button onClick={this.prevPage}>Prev</button>
                {typeSelected === 'DAILY'
                  ? `${dailyPageCount}/${Math.ceil(dailyStatementCount / 10)}`
                  : `${monthlyPageCount}/${Math.ceil(
                    totalMonthlyStatement / 10
                  )}`}
                <button onClick={this.nextPage}>Next</button>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default PreDailyPage;